import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; }
  return a;
};

const ScrollingIcons = () => {
  const [icons, setIcons] = useState([]);
  const { i18n } = useTranslation();
  const isZh = i18n.language === 'zh';

  useEffect(() => {
    const load = async () => {
      try { const r = await axios.get(`${API}/admin/scroll-icons`); setIcons(r.data.icons || []); } catch {}
    };
    load();
  }, []);

  const t = (icon, field) => isZh ? (icon[`${field}_zh`] || icon[field] || '') : (icon[`${field}_en`] || icon[field] || '');

  const groups = useMemo(() => {
    if (icons.length === 0) return [];
    const shuffled = shuffle(icons);
    const perGroup = Math.ceil(shuffled.length / 3);
    return [0, 1, 2].map(i => {
      const slice = shuffled.slice(i * perGroup, (i + 1) * perGroup);
      return [...slice, ...slice, ...slice];
    });
  }, [icons]);

  if (icons.length === 0) return null;

  const renderItem = (icon, key) => (
    <div key={key} className="flex-shrink-0 bg-white rounded-xl shadow-sm flex items-center justify-center" style={{ width: '180px', height: '80px', margin: '10px' }}>
      {icon.image && <img src={icon.image} alt={t(icon, 'name')} className="max-h-14 max-w-[150px] object-contain" />}
      {(t(icon, 'text') || (!icon.image && t(icon, 'name'))) && (
        <span className="text-sm font-semibold text-gray-700 whitespace-nowrap">{t(icon, 'text') || t(icon, 'name')}</span>
      )}
    </div>
  );

  // Alternate directions: left, right, left, right
  const directions = ['left', 'right', 'left'];
  const speeds = [60, 70, 65]; // slower speeds in seconds

  return (
    <section className="py-14 bg-gray-100 overflow-hidden">
      <div className="space-y-5">
        {groups.map((group, gi) => (
          <div key={gi} className="relative">
            <div className={`flex items-center animate-marquee-${directions[gi]}-slow`}
              style={{ width: 'max-content', animationDuration: `${speeds[gi]}s`, gap: '0px' }}>
              {group.map((icon, i) => renderItem(icon, `g${gi}-${i}`))}
            </div>
          </div>
        ))}
      </div>
      <style>{`
        @keyframes marquee-left-slow { 0% { transform: translateX(0); } 100% { transform: translateX(-33.333%); } }
        @keyframes marquee-right-slow { 0% { transform: translateX(-33.333%); } 100% { transform: translateX(0); } }
        .animate-marquee-left-slow { animation: marquee-left-slow linear infinite; }
        .animate-marquee-right-slow { animation: marquee-right-slow linear infinite; }
      `}</style>
    </section>
  );
};

export default ScrollingIcons;
